var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button-group',{staticClass:"ProductUpsell ProductUpsell__Checkbox"},[_c('div',{staticClass:"description"},[_c('b',[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('small',[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }